import { render } from "./FormButtonVK.vue?vue&type=template&id=c2b02a8c&lang=pug"
import script from "./FormButtonVK.vue?vue&type=script&lang=js"
export * from "./FormButtonVK.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__